import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { TextField, Box, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import InputMask from "react-input-mask";
import { scrollToTop } from "../formHelpers";
import { BOND_STEP_DATA_UPDATE_ERRORS } from "../bondWizardStepPropTypes";

const RequestorInformation = ({
  data,
  updateData,
  errors,
  respectExistingData = true,
}) => {
  const userdetails = useSelector((state) => state.auth.user);
  const phoneNumber = useSelector((state) => state.auth);

  const cleanPhoneNumber = (phone) => {
    if (!phone) return "";
    return phone.replace(/^\+1/, "").replace(/\D/g, "");
  };

  useEffect(() => {
    if (!userdetails?.email) return;

    const hasExistingRequestor = data?.email || data?.firstNameReq || data?.lastNameReq;
    if (respectExistingData && hasExistingRequestor) return;

    updateData({
      ...data,
      email: userdetails.email,
      firstNameReq: userdetails.first_name,
      lastNameReq: userdetails.last_name,
      phoneNumber: data.phoneNumber || cleanPhoneNumber(phoneNumber.phoneNumber),
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    updateData({ ...data, [name]: value });
  };

  useEffect(() => {
    scrollToTop();
  }, []);

  return (
    <Box
      className="bg-gray-100 p-6 rounded-lg shadow-md max-w-3xl mx-auto mt-8"
      sx={{ border: "1px solid #e0e0e0" }}
    >
      <Typography variant="h5" className="font-bold mb-4">
        Requestor Information
      </Typography>

      <Box className="grid grid-cols-1 gap-4">
        <TextField
          label="First Name"
          name="firstNameReq"
          value={data.firstNameReq || ""}
          onChange={handleChange}
          fullWidth
          required
          error={!!errors.firstNameReq}
          helperText={errors.firstNameReq}
        />

        <TextField
          label="Last Name"
          name="lastNameReq"
          value={data.lastNameReq || ""}
          onChange={handleChange}
          fullWidth
          required
          error={!!errors.lastNameReq}
          helperText={errors.lastNameReq}
        />

        <TextField
          label="Email"
          name="email"
          value={data.email || ""}
          onChange={handleChange}
          fullWidth
          required
          error={!!errors.email}
          helperText={errors.email}
        />

        <InputMask
          mask="(999) 999-9999"
          value={data.phoneNumber || ""}
          onChange={handleChange}
        >
          {(inputProps) => (
            <TextField
              {...inputProps}
              label="Phone Number"
              name="phoneNumber"
              fullWidth
              required
              error={!!errors.phoneNumber}
              helperText={errors.phoneNumber}
            />
          )}
        </InputMask>
      </Box>
    </Box>
  );
};

RequestorInformation.propTypes = {
  ...BOND_STEP_DATA_UPDATE_ERRORS,
  respectExistingData: PropTypes.bool,
};

export default RequestorInformation;
